export const ANNOTATION_DASHBOARD_FIELDS: Record<string, Array<string>> = {
  online_ce_performance: ["brands", "regions", "markets", "models", "channels", "channel_breakdowns", "metrics", "metric_types", "tags"],
  purchase_funnel: ["brands", "markets", "lead_sources", "metrics"],
  mtm_metrics_that_matter: ["models", "markets", "metrics"],
};
